<!-- Content Spacer Goes Here -->
<!-- Content Spacer Goes Here -->
<div
  class="spacer"
  *ngIf="mode === 'FIXED' && !visibility.isHidden"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
  [ngStyle]="{ 'height.px': height }"
></div>
